import { Box, Divider, Typography, styled } from '@mui/material'
import React from 'react'
import { emptyChatImage } from '../../Statics/Data'




const Components=styled(Box)`
background:#f8f9fa;
padding: 30px 0;
text-align:center;
height:100vh;
`

const Container=styled(Box)`
padding:0 200px
`

const Image=styled("img")({
    width:400,
    marginTop:100


})
const Text=styled(Typography)`
font-size:32px;
margine:25px 0 10px 0;
font-faimly:inherit;
font-weight:300;
color:#41525d;

`

const SubTitle=styled(Typography)`
font-size:14px;
font-faimly:inherit;
font-weight:400;
color:#667781;

`

const StyledDivder=styled(Divider)`
margin: 40px 0;
opacity:0.4;

`









function EmptyChat() {

 

    return (
        <Components>
            <Container>
                <Image src={emptyChatImage}></Image>
                <Text>WhatsApp Web</Text>
                <SubTitle>Now send and receive message without keeping your phone online</SubTitle>
                <SubTitle>Use WhatsApp on up to 4 linked device and 1 phone at the same time</SubTitle>
                <StyledDivder/>
            </Container>
        </Components>
    )
}

export default EmptyChat
